function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechNeedsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.559,10L6.57,10C6.94,10 7.126,10 7.304,10.038C7.366,10.05 7.426,10.066 7.486,10.086C7.66,10.142 7.82,10.234 8.142,10.417C9.159,10.999 9.668,11.289 10.219,11.348C10.405,11.368 10.594,11.368 10.78,11.348C11.332,11.289 11.84,10.999 12.857,10.417C13.179,10.234 13.339,10.142 13.513,10.086C13.573,10.066 13.633,10.05 13.695,10.038C13.874,10 14.059,10 14.429,10L18.44,10L18.44,13.529C18.44,15.193 18.44,16.025 17.924,16.542C17.407,17.059 16.575,17.059 14.911,17.059L6.088,17.059C4.424,17.059 3.592,17.059 3.075,16.542C2.559,16.025 2.559,15.193 2.559,13.529L2.559,10Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(154,154,154)",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.559,11.765L2.559,9.412C2.559,8.829 2.559,8.537 2.649,8.266C2.74,7.994 2.915,7.761 3.264,7.294L5.47,4.353C5.99,3.66 6.25,3.314 6.622,3.128C6.995,2.941 7.428,2.941 8.294,2.941L12.705,2.941C13.571,2.941 14.004,2.941 14.377,3.128C14.749,3.314 15.009,3.66 15.529,4.353L17.735,7.294C18.084,7.761 18.259,7.994 18.35,8.266C18.44,8.537 18.44,8.829 18.44,9.412L18.44,11.765",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(154,154,154)",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,5.833L13,5.833",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(154,154,154)",
      strokeWidth: "0.83px",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.334,7.5L14.667,7.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(154,154,154)",
      strokeWidth: "0.83px",
      strokeLinecap: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechNeedsNormal);
export default __webpack_public_path__ + "static/media/speech_needs_normal.c7fc42e982f703394d71d77a34cdf50e.svg";
export { ForwardRef as ReactComponent };